(function (window) {
  'use strict';

  const openClass = 'js-product-compare--open';
  const openBodyClass = 'js-product-compare-open';
  let previousScrollTop = null;

  function handleToggle(e) {
    const instance = e.target.closest('.js-product-compare');

    if (!instance.classList.contains(openClass)) {
      openInstance(instance);
    }
    else {
      closeInstance(instance);
    }
  }

  function openInstance(instance = document.querySelector('.js-product-compare')) {
    // iOS requires `body { position: fixed }` to prevent background scrolling
    // while the modal is open, which forces the page to jump to the top. The
    // following counteracts that jump.
    previousScrollTop = (document.documentElement.scrollTop || document.body.scrollTop);
    document.body.style.top = (-1 * previousScrollTop) + 'px';
    document.body.classList.add(openBodyClass);

    instance.classList.add(openClass);
  }

  function closeInstance(instance = document.querySelector('.js-product-compare')) {
    // Undoes the positioning fix from openInstance().
    document.body.classList.remove(openBodyClass);
    document.body.style.top = '';
    document.documentElement.scrollTop = document.body.scrollTop = previousScrollTop;

    instance.classList.remove(openClass);
  }

  function handleControl(e) {
    const control = e.target;
    const body = control.closest('.js-product-compare-body');

    if (body) {
      const direction = control.getAttribute('data-direction');
      let currentPosition = parseInt(body.getAttribute('data-position'));

      if (direction == 'prev' && currentPosition > 1) {
        currentPosition--;
      }
      else if (direction == 'next' && currentPosition < 3) {
        currentPosition++;
      }

      body.setAttribute('data-position', currentPosition);
    }
  }

  function handleSwipe(element, direction) {
    const instance = element.closest('.js-product-compare');
    const controlDirection = (direction == 'left') ? 'prev' : 'next';
    const control = instance.querySelector('.js-product-compare-control[data-direction="' + controlDirection + '"]');

    if (control) {
      control.click();
    }
  }

  function init() {
    const instances = document.querySelectorAll('.js-product-compare');

    for (let i = 0; i < instances.length; i++) {
      if (!instances[i].classList.contains('js-component-init')) {
        const toggle = instances[i].querySelector('.js-product-compare-toggle');
        const controls = instances[i].querySelectorAll('.js-product-compare-control');
        const swipeElement = instances[i].querySelector('.js-swipe');

        toggle.addEventListener('click', handleToggle);

        for (let i = 0; i < controls.length; i++) {
          controls[i].addEventListener('click', handleControl);
        }

        if (typeof swipeElement.events !== 'undefined') {
          swipeElement.events.on('swipe', handleSwipe);
        }

        instances[i].classList.add('js-component-init');
      }
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
    componentEvents.on('product-compare-open', openInstance);
    componentEvents.on('product-compare-close', closeInstance);
  }

  init();

})(this);
